const styles = theme => ({
	root: {
		display: 'flex',
	},

	editIcon: {
		color: '#009AC9',
	},

	editZonesIcon: {
		fill: '#009AC9',
	},

	icons: {
		display: 'flex',
	},

	checkIcon: {
		color: '#51B383',
	},
});

export default styles;